import React from "react";

import { Modal, Group, Text, Stack, Title, Card, CloseButton } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";

import { MailChimpUpsellPaidSignup } from "../MailChimpUpsellPaidSignup";

interface UpSellModalProps {
  opened: boolean;
  toggle: () => void;
}

export function UpSellModal(props: UpSellModalProps): JSX.Element {
  return (
    <Modal
      centered
      withCloseButton={false}
      opened={props.opened}
      onClose={props.toggle}
      size={480}
      styles={{
        title: {
          textAlign: "center",
        },
        content: {
          borderRadius: "8px",
        },
      }}
    >
      <Card
        pos="relative"
        withBorder={false}
        p={{
          base: 24,
          sm: 32,
        }}
      >
        <CloseButton
          onClick={props.toggle}
          size="lg"
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
          }}
        />
        <Stack gap={8}>
          <Group justify="center">
            <IconSparkles size={24} />
            <Title order={3}>Get Pro Features</Title>
          </Group>
          <Text size="sm" ta="center" pb={16}>
            Join our waitlist to know when we release pro features like data exports, saved
            searches, pay range creation, and more.
          </Text>
          <MailChimpUpsellPaidSignup cancel={props.toggle} />
        </Stack>
      </Card>
    </Modal>
  );
}
